import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/foods.vue'
wx.createPage(MiniProgramPage)